module.exports = __webpack_public_path__ + "static/media/11-speaker_profile.ca67cff3.webp";